<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Detalle de la media`,
        },
      ]"
    />
    <div v-if="loading" class="text-center">
      <Loader />
    </div>

    <div v-else>
      <div class="card ml-3 mr-3 mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <!-- LATITUD -->
              <div class="form-group">
                <label class="titleLabel">Nombre de la media: </label>
                <label class="title ml-2" v-if="mediaFile == null">{{
                  media.fileName
                }}</label>
                <label class="title ml-2" v-else>{{ mediaFile.name }}</label>
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="removeMedia(media.Id)"
                >
                  Eliminar Media
                </button>
                <button
                  class="btn btn-outline-primary ml-4"
                  type="button"
                  @click="updateMedia(media.Id)"
                >
                  Actualizar Media
                </button>
              </div>
            </div>
            <div class="col-sm-6">
              <label v-if="media.typeOfFile == 'img'">Imagen de portada</label>
              <label v-else
                >Video (click en la imagen para subir el video)</label
              >
              <div class="card mb-3" style="width: 80%; height: 250px">
                <img
                  v-if="media.typeOfFile == 'img'"
                  class="card-img-top"
                  :src="media.FileLocation"
                  @click="handleFileChangeAlbum"
                  style="width: 100%; height: 250px"
                />
                <img
                  v-else
                  @click="handleFileChangeAlbum"
                  class="card-img-top"
                  src="../../assets/video.jpg"
                  style="width: 100%; height: 250px"
                />

                <div class="card-body">
                  <input
                    type="file"
                    class="custom-file-input"
                    ref="fileInputAlbum"
                    @change="handleFileChangeAlbum"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import { UtilsService } from "../../services/UtilsService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  components: {
    Loader,
    Breadcrumbs,
  },
  data() {
    return {
      media: null, // Initial media list with one empty item
      mediaFile: null,
      companyService: new CompanyService(),
      utilService: new UtilsService(),
      title: "",
      loading: false,
    };
  },
  mounted: async function () {
    this.getMedia();
  },
  methods: {
    async updateMedia() {
      try {
        Swal.fire({
          title: "Esta seguro de actualizar la media?",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Actualizar",
          denyButtonText: `Don't save`,
        }).then(async (result) => {
          if (result.dismiss != "cancel") {
            this.loading = true;
            if (this.mediaFile == null) {
              this.$helpers.message(
                "Error",
                "No se ha seleccionado ningun archivo.",
                "error"
              );
              this.loading = false;
              return;
            }
            let galeryBase64 = await this.fileToBase64(this.mediaFile);
            let url = await this.utilService.uploadFile(
              this.mediaFile.name,
              galeryBase64
            );
            var data = {
              id: this.media.Id,
              documentName: this.mediaFile.name,
              url: url,
            };

            const res = await this.companyService.updateMedia(data);
            if (res.ok) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Se ha actualizado correctamente.",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.go(-1);
            }
          }
          this.loading = false;
          this.getMedia();
        });
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async removeMedia(id) {
      try {
        Swal.fire({
          title: "Esta seguro de eliminar la media?",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          denyButtonText: `Don't save`,
        }).then(async (result) => {
          if (result.dismiss != "cancel") {
            this.loading = true;
            const res = await this.companyService.deleteMedia(id);
            if (res.ok) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Se ha eliminado correctamente.",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.go(-1);
            }
          }
          this.loading = false;
        });
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },
    async getMedia() {
      try {
        this.loading = true;
        const res = await this.companyService.getMedia(this.$route.params.id);
        this.media = res.data;

        this.loading = false;
      } catch (err) {
        this.$helpers.message("Error", err.message, "error");

        this.loading = false;
      }
    },

    handleFileChangeAlbum() {
      this.$refs.fileInputAlbum.click();
      const input = this.$refs.fileInputAlbum;
      if (input && input.files.length > 0) {
        this.mediaFile = input.files[0];
      }
    },

    getMediaUrl(file) {
      console.log("file", file);
      return URL.createObjectURL(file);
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.split(",")[1]);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style>
/* Apply styles to the label */
.titleLabel {
  font-size: 1em !important; /* Adjust the font size */
  font-weight: bold !important; /* Make the text bold */
  margin-bottom: 10px !important; /* Add some spacing below the label */
  color: #333 !important; /* Set the text color */
}
.title {
  font-size: 1.1em !important; /* Adjust the font size */

  margin-bottom: 10px !important; /* Add some spacing below the label */
  color: grey !important; /* Set the text color */
}
</style>
